import axios from "axios";
import FloatTitleCard from "../../cards/floatTitleCard";
import { useEffect, useRef, useState } from "react";
import serverConfig from '../../../utilities/serverConfig.json'
import apiConfig from '../../../utilities/apiConfig.json'
import PersonIcon from '@mui/icons-material/Person';
import { useSelector } from "react-redux";

const EditUserModal = (userData) => {

    const { token } = useSelector((state) => state.user);

    const tokenLocal = localStorage.getItem("token");
    const headers = { Authorization: "Bearer " + (token ? token : tokenLocal) };

    const [uploadedFile, setUploadedFile] = useState(null)
    const [blobsrc, setBlobSrc] = useState(null)

    const [{
        user_id,
        first_name,
        last_name,
        biography,
        city_id,
        city_name,
        file,
        mobile,
        national_id,
        province_id,
        province_name
    }, setUserDataForm] = useState({ ...userData })

    const updateForm = (key, value) => {
        setUserDataForm(prev => ({ ...prev, [key]: value }))
    }

    const handlePictureFile = e => {

        const fileData = e.target.files?.[0]

        if (fileData) {

            const fileReader = new FileReader()

            fileReader.onload = event => setBlobSrc(event.target.result)

            fileReader.readAsDataURL(fileData)
        }

        e.target.files = null;

    }

    const removePicFile = () => {
        setBlobSrc(null)
        setUploadedFile(null)
    }

    const [submitLoading, setSubmitLoading] = useState(false)
    const modalRef = useRef(null)

    const udpateUserData = async () => {

        const updateRoute = serverConfig.server.url + apiConfig.api.updateAPIs.updateDoctor

        const updatedData = { user_id, first_name, last_name, biography, city_id, city_name, file, mobile, national_id, province_id, province_name }

        try {

            setSubmitLoading(true)

            const { data, status } = await axios.post(updateRoute, updatedData, { headers })
            console.log(status, data)

        } catch (error) { console.log(error) }
        finally { setSubmitLoading(false) }

    }

    useEffect(() => {

        const updateModal = () => setUserDataForm(userData)

        if (modalRef.current) {
            modalRef.current.addEventListener('hidden.bs.modal', updateModal)
            modalRef.current.addEventListener('show.bs.modal', updateModal)
        }

        return () => {
            modalRef?.current?.removeEventListener('hidden.bs.modal', updateModal)
            modalRef?.current?.removeEventListener('show.bs.modal', updateModal)
        }

    }, [modalRef, userData])

    return (
        <div
            className="modal fade"
            id="editUserData"
            ref={modalRef}
            tabIndex="-1"
            aria-labelledby="editUserDataLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">

                <div className="modal-content">

                    <div className="modal-header">

                        <h5 className="modal-title fs-16 " id="editUserDataLabel">مشخصات نوبت</h5>

                        <img
                            style={{ cursor: 'pointer' }}
                            className="rounded-5 ms-auto"
                            data-bs-dismiss="modal"
                            aria-label="بستن"
                            src="./cancel.png"
                            alt="cancel.png"
                        />

                    </div>

                    <div className="modal-body d-flex gap-3 flex-column">

                        <span>برای ویرایش هر قسمت روی بخش موردنظر کلیک کنید .</span>

                        <div
                            id="user_picture_container"
                            className="rounded-2 py-2 px-3 d-flex align-items-center justify-content-between"
                        >

                            <div
                                id="user_profile_container"
                                className="rounded-5 d-flex tw-size-[54px] align-items-center justify-content-center position-relative"
                            >

                                {
                                    blobsrc
                                        ?
                                        <img className="tw-size-[51px] tw-bg-center tw-object-cover tw-rounded-full" src={blobsrc} />
                                        :
                                        <PersonIcon className="background-bootstrap-gray-500 tw-size-full tw-rounded-full tw-p-2" />
                                }

                                <span
                                    onClick={removePicFile}
                                    id="user_image"
                                    className="position-absolute d-flex align-items-center justify-content-center rounded-2"
                                >
                                    <img src="./delete.png" alt="delete.png" />
                                </span>

                            </div>

                            <input onChange={handlePictureFile} accept="image/*" type="file" id="pic-input" className="tw-hidden tw-invisible" />

                            <label
                                htmlFor="pic-input"
                                style={{ height: '29px', cursor: 'pointer' }}
                                className="py-1 px-2 rounded-2 d-flex align-items-center justify-content-between bg-primary gap-2"
                            >
                                <div className="bg-primary">
                                    <img src="./change_circle.png" alt="change_circle.png" />
                                </div>

                                <p className="m-0 text-white">تغییر</p>
                            </label>

                        </div>

                        <FloatTitleCard padding={2} paddingTop={2} title={"نام"} error={false}>
                            <input
                                type="text"
                                value={first_name ?? ''}
                                onChange={e => updateForm('first_name', e.target.value)}
                                className="border-none w-100 border-0"
                            />
                        </FloatTitleCard>

                        <FloatTitleCard padding={2} paddingTop={2} title={"نام خانوادگی"} error={false}>
                            <input
                                type="text"
                                value={last_name ?? ''}
                                onChange={e => updateForm('last_name', e.target.value)}
                                className="border-none w-100 border-0"
                            />
                        </FloatTitleCard>

                        <FloatTitleCard padding={2} paddingTop={2} title={'استان'} error={false}>
                            <input
                                type="text"
                                value={province_name ?? ''}
                                onChange={e => updateForm('province_name', e.target.value)}
                                className="border-none w-100 border-0"
                            />
                        </FloatTitleCard>

                        <FloatTitleCard padding={2} paddingTop={2} title={'شهر'} error={false}>
                            <input
                                type="text"
                                value={city_name ?? ''}
                                onChange={e => updateForm('city_name', e.target.value)}
                                className="border-none w-100 border-0"
                            />
                        </FloatTitleCard>

                        <FloatTitleCard padding={2} paddingTop={2} title={'کد ملی'} error={false}>
                            <input
                                type="text"
                                value={national_id ?? ''}
                                onChange={e => updateForm('national_id', e.target.value)}
                                className="border-none w-100 border-0"
                            />
                        </FloatTitleCard>

                        <FloatTitleCard padding={2} paddingTop={2} title={'شماره همراه'} error={false}>
                            <input
                                type="text"
                                value={mobile ?? ''}
                                onChange={e => updateForm('mobile', e.target.value)}
                                className="border-none w-100 border-0"
                            />
                        </FloatTitleCard>

                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            onClick={udpateUserData}
                            className="btn btn-primary w-100"
                        >
                            {submitLoading ? "در حال ثبت..." : "تایید مشخصات"}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default EditUserModal;
